<template>
  <BaseModal 
    :show="show"
    size="sm" 
    title="Eliminar Regla"
    :show-actions="true"
    save-text="Eliminar"
    save-class="bg-red-600 hover:bg-red-700"
    @close="$emit('close')"
    @save="$emit('confirm-delete')"
  >
    <div class="flex items-center mb-4">
      <div class="w-12 h-12 bg-red-100 dark:bg-red-900 rounded-full flex items-center justify-center mr-4">
        <i class="fas fa-exclamation-triangle text-red-600 dark:text-red-400" />
      </div>
      <div>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Esta acción no se puede deshacer
        </p>
      </div>
    </div>
    
    <div class="mb-4">
      <p class="text-gray-700 dark:text-gray-300">
        ¿Estás seguro de que quieres eliminar la regla "<strong>{{ ruleName }}</strong>"?
      </p>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '@/components/common/BaseModal.vue'

interface Props {
  show: boolean
  ruleName: string
}

defineProps<Props>()

defineEmits<{
  close: []
  'confirm-delete': []
}>()
</script>
